"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PriceZoneProductPrice_1 = require("./PriceZoneProductPrice");
/**
 * Data transfer object for data cleaning overview.
 *
 * @author RV
 */


var InternalProductPricesDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(InternalProductPricesDTO, _DomainObject_1$Domai);

  /**
   *
   * @param internalProductId
   * @param purchasePrice purchase price of internal product
   * @param prices list of prices for each price zone
   */
  function InternalProductPricesDTO(internalProductId, purchasePrice, openPurchasePrice, prices) {
    var _this;

    _classCallCheck(this, InternalProductPricesDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternalProductPricesDTO).call(this));
    _this.internalProductId = internalProductId;
    _this.purchasePrice = purchasePrice;
    _this.openPurchasePrice = openPurchasePrice;
    _this.prices = prices;
    return _this;
  }

  return InternalProductPricesDTO;
}(DomainObject_1.DomainObject);

exports.InternalProductPricesDTO = InternalProductPricesDTO;

InternalProductPricesDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(InternalProductPricesDTO.name);
  return {
    internalProductId: builder.str('internalProductId'),
    purchasePrice: builder.bigNum('purchasePrice'),
    openPurchasePrice: builder.opt(builder.bigNum('openPurchasePrice')),
    prices: builder.listOf(builder.obj('prices', PriceZoneProductPrice_1.PriceZoneProductPrice.schema, function (mat) {
      return new PriceZoneProductPrice_1.PriceZoneProductPrice(mat.priceZoneId, mat.actualRegularPrice, mat.actualMarginPrice, mat.actualMarginPercentage, mat.unitPrice);
    }))
  };
}();